import { SchedulePkModel } from "./schedulePkModel";

export class CancelScheduleRequestModel extends SchedulePkModel {
    cancelUser: string;
    reschedule: boolean;

    constructor(division: number, country: string | null, dealer: number, advisor: number, scheduleHour: number, scheduleDate: string,
                cancelUser: string, reschedule: boolean) {
      super(division, country, dealer, advisor, scheduleHour, scheduleDate);
      this.cancelUser = cancelUser;
      this.reschedule = reschedule;
    }
  }
